<template>
  <div class="overview">
    <div v-if="showCompanySelector" class="container__company-selector">
      <company-selector @companySelected="setSelectedCompany"></company-selector>
    </div>
    <div v-else class="columns is-multiline is-variable is-full is-margin-top-desktop">
      <div class="column is-half">
        <div class="box white">
          <h1 class="title">Latest Project</h1>
          <div class="content">
            <div class="column is-12 link" v-if="projects[0]" @click="setProject(projects[0])">
              <project-card :project-details="projects[0]"
                            :icon-type="getIconTypeForProject(projects[0])"></project-card>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-half hide-on-mobile">
        <div class="slider-container box">
          <ad-carousel></ad-carousel>
        </div>
      </div>
      <div class="column is-full">
        <div class="projects-container">
          <h1 class="title title-line-middle">All Projects</h1>
          <div class="content">
            <div v-if="filteredProjects.length >= 1" class="columns is-multiline is-variable is-full">
              <div v-for="project in filteredProjects" class="link column is-6" @click="setProject(project)">
                <project-card :project-details="project" :icon-type="getIconTypeForProject(project)"></project-card>
              </div>
            </div>
            <div v-else class="columns is-multiline is-variable is-full">
              <div v-for="project in projects" class="link column is-6" @click="setProject(project)">
                <project-card :project-details="project" :icon-type="getIconTypeForProject(project)"></project-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectCard from "../../../../../resource/component/project-card/component.vue";
import CompanySelector from "../../../../../resource/component/company-selector/component.vue";
import AdCarousel from "../../../../../resource/component/ad-carousel/component.vue";

const INVALID_STATES = ['EXCLUDED', 'ARCHIVED', 'DELETED', 'REMOVED'];

export default {
  name: "overview",
  components: {
    AdCarousel,
    ProjectCard,
    CompanySelector
  },
  created() {
    this.$store.commit('generic/showSearchBar', false);
    this.$store.dispatch('company/clearFilteredProjects');
  },
  data() {
    return {}
  },
  computed: {
    company() {
      return this.$store.state.company.selected.company;
    },
    filteredProjects() {
      return this.$store.state.company.filteredCompanyProjects;
    },
    projects() {
      const projects = _.get(this.$store.state.company.selected.company, 'projects.all', []);
      const filteredProjects = projects.filter(project => {
        if (this.isExternalUser) {
          return project.id !== null && _.get(project, 'servicesForProject', []).includes('internalTakeOff') === false && INVALID_STATES.includes(_.get(project, 'state.project')) === false;
        }

        return project.id !== null && INVALID_STATES.includes(_.get(project, 'state.project')) === false;
      }) || [];

      return filteredProjects.reverse();
    },
    latestProject() {
      return this.projects[0] ?? null;
    },
    isExternalUser() {
      return this.$store.getters['user/isExternalCompany'];
    },
    showCompanySelector() {
      return this.isExternalUser === false && _.isEmpty(this.company);
    },
  },
  methods: {
    setSelectedCompany(companyId) {
      this.$store.dispatch('company/select', {
        _id: companyId
      });
    },
    setProject(project) {
      this.$store.dispatch('quote/select', {
        ref: project.ref
      }).then(() => {
        this.$router.push({
          name: 'project',
        });
        this.$store.dispatch('company/filterCompanyProjects', null);
      }).catch((error) => {
        console.error(error);
      });
    },
    getIconTypeForProject(project) {
      if (_.indexOf(project.servicesForProject, 'primaryCostEstimate') !== -1) {
        return 'pce';
      }

      return 'standard';
    }
  },
}
</script>

<style lang="scss" scoped>
.overview {
  height: 100%;
  width: 100%;

  .adds {
    @include box-shadow(2px 2px 10px rgba(0, 0, 0, 0.6));
  }

  .projects {
    display: flex;
    flex-direction: column;
    margin-top: 2.5em;

    @include tablet--large {
      gap: 1em;
    }

    @media screen and (min-width: $phone) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(auto-fit, minmax(100px, auto));
      grid-gap: 20px;
      margin-top: 5em;
    }

    @media screen and (min-width: $tablet--large) {
      grid-template-columns: repeat(3, 1fr);
    }

    .link {
    }
  }

  .slider-container {
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    height: 100%;
    box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.2), 0 0px 0 1px rgba(10, 10, 10, 0.04);
  }

  .container__company-selector {
    @include box-shadow(2px 2px 10px rgba(0, 0, 0, 0.6));

    background-color: $primary;
    color: $primary-font-color;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    padding: 20px;
    //background-color: $primary;
    width: 450px;
    margin: 25% auto;

    @include tablet--large {
      width: 300px;
    }
  }

  .box {
    height: 100%;
  }

  .projects-container {
    @media screen and (min-width: $tablet--large) {
      margin-top: 2em;
    }

    max-height: none;
    overflow: hidden;
    padding: 2rem;
  }

  .link {
    text-decoration: none;

    &:hover {
      cursor: pointer;
    }
  }

  .title-line-middle {
    text-align: center;
    overflow: visible;
    white-space: nowrap;
    margin-bottom: 2em;
  }

  .title-line-middle::before,
  .title-line-middle::after {
    content: '';
    position: relative;
    display: inline-block;
    width: 50%;
    height: 1px;
    vertical-align: middle;
    background: $primary; /* or whatever color you want */
  }

  .title-line-middle::before {
    right: 0.5em;
    margin-left: -50%;
  }

  .title-line-middle::after {
    left: 0.5em;
    margin-right: -50%;
  }

  @media screen and (min-width: $tablet--large) {
    .is-margin-top-desktop {
      margin-top: 2em;
    }
  }
}
</style>